// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kuhF","label":"styles_label__3JtOz"};